import React from 'react'

export default function Footer() {
  return (
    <>
    <footer>
      <section id="contacto" className="zonaContacto w-100  ">
        <section className="d-flex  align-items-center justify-content-center flex-wrap">
          <p className="fs-5 px-3 pt-3">Auto Gas Yony &copy; Copyright 2023 </p>

          <a  href="https://web.facebook.com/Auto-Gas-Yoni-277949276434981/?_rdc=1&_rdr" target="_blank">
<i class="bi bi-facebook"></i>

          </a>
          
          <a href="https://www.youtube.com/@tomasj.reyes.s7550/videos" target="_blank">
 <i class="bi bi-youtube" ></i>
          </a>
         
        
        
        </section>
      </section>
      </footer>
    </>
  );
}
